export const currentSchool = (data) => {
    return {
        type: 'CURRENT_SCHOOL',
        data,
    }
}
